import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Outlet } from 'react-router-dom';
import PdfViewerHost from '../components/shared/PdfViewer/PdfViewerHost';
import DocumentExpiryBanner from '../components/shared/DocumentExpiryBanner/DocumentExpiryBanner';
import { killServiceWorker } from '../serviceWorkerRegistration';
import './App.css';

function App() {
    useEffect(() => {
        // The "Prepare for offline" feature has been removed. Actively unregister
        // any previously-installed service worker and purge its caches so devices
        // stop serving a stale, cached app shell.
        killServiceWorker();
    }, []);
    return (
        <div className="App">
            <DocumentExpiryBanner />
            <PdfViewerHost />
            <Outlet />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
}

export default App;
